<script setup lang="ts">
    import { trackEvent } from '@/plugins/amplitude';
    import { APP_TARGETS } from '@/domain/analytics/analyticsTargets';

    const onShowSurveyClick = () => {
        trackEvent('show_feedback_survey');
    };
</script>

<template>
    <v-menu
        max-height="500"
        max-width="500"
        content-class="support-menu"
        transition="fade-transition"
        :open-on-hover="true"
        location="bottom"
        offset="30"
        open-delay="0"
        close-delay="0"
    >
        <template #activator="{ props }">
            <v-hover>
                <template #default="{ isHovering, props: hoverProps }">
                    <app-menu-item
                        data-testid="header-support-menu"
                        :data-analytics-id="APP_TARGETS.helpIcon"
                        v-bind="{ ...hoverProps }"
                        :background="isHovering ? 'light' : 'dark'"
                        class="cursor-pointer mr-5"
                        icon="mdi-help-circle-outline"
                        @focus="props.onFocus"
                        @blur="props.onBlur"
                        @mouseenter="props.onMouseenter"
                        @mouseleave="props.onMouseleave"
                    />
                </template>
            </v-hover>
        </template>
        <v-card
            dense
            min-width="400"
            color="dark-blue"
            class="notifications-card"
            data-testid="header-support-menu-content"
        >
            <v-list dense class="pa-5 overflow-y-auto">
                <v-list-item
                    href="https://support.formuslabs.com/hc/en-us"
                    target="_blank"
                    data-testid="header-support-menu-knowledge-link"
                >
                    Knowledge Base
                </v-list-item>

                <v-divider />

                <v-list-item
                    target="_blank"
                    class="font-weight-bold"
                    data-testid="header-support-menu-provide-link"
                    @click="onShowSurveyClick"
                >
                    Provide Instant Feedback
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<style scoped lang="scss">
    .support-menu {
        .v-list {
            background: var(--v-dark-blue);
            color: var(--v-planner-grey-lighten-1);
        }
    }

    .survey-container {
        display: none; /* Initially hidden */
        /* Additional styling if needed */
    }
</style>
